import { MatchAPI } from "../src/apis/MatchAPI"
import moment from "moment"
import { getNavigationProps } from "@components/Navigation/getNavigationProps"
import { SEO } from "../src/types/next.js"
import InferNextPropsType from "infer-next-props-type"
import { Col, Row } from "react-bootstrap"
import { Newsletter } from "@components/Home/Newsletter"
import { MatchesDate } from "@components/Match/MatchesDate"
import React from "react"

export default function MatchesListPage({ matches }: InferNextPropsType<typeof getServerSideProps>) {
  return (
    <>
      <Row className={"marginZero"}>
        <Col md={12} className="paddingZero">
          <div id="hs-content" className={"paddingFive"}>
            <MatchesDate matches={matches} />
          </div>
        </Col>
        <Col md={12}>
          <Row>
            <Newsletter />
          </Row>
        </Col>
      </Row>
    </>
  )
}

// getServerSideProps and not getStaticProps because this page must be generated each time
// it is hit by a user
export async function getServerSideProps() {
  try {
    const now = moment()
    const [matches] = await Promise.all([
      MatchAPI.getPublicMatchesByDate(now.format("YYYY-MM-DD"), false, false, false, false),
    ])

    const title = `Risultati Calcio Live: le partite di oggi in diretta`
    const seo: SEO = {
      title: title,
      description: `Partite di calcio in tempo reale! Segui tutti i campionati dalla Serie A alla Champions League fino alla Premier League. Piú di 1000 campionati disponibili`,
      keywords: ["Partite", "calcio", now.format("DD-MM-YYYY")],
      canonicals: ["/live-risultati"],
    }

    return {
      props: {
        matches,
        seo,
        title,
        navigationProps: await getNavigationProps(),
      },
      // live pages should not be cached!
      // revalidate: NextConstants.REVALIDATE,
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }
}
